import { render, staticRenderFns } from "./OrderProductsPriceDetailComponent.vue?vue&type=template&id=7771bdb5&"
import script from "./OrderProductsPriceDetailComponent.vue?vue&type=script&lang=js&"
export * from "./OrderProductsPriceDetailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports